<div class="card">
    <!-- Corner markers -->
    <div class="corner corner--top-left"></div>
    <div class="corner corner--top-right"></div>
    <div class="corner corner--bottom-left"></div>
    <div class="corner corner--bottom-right"></div>

    <img [ngSrc]="image" [alt]="alt" class="card__image" fill />

    <div class="card__overlay"></div>

    <div class="card__grid"></div>

    <div class="card__content">
        <h3 class="card__title">{{ title }}</h3>
        <p class="card__description">{{ description }}</p>
    </div>

    <div class="card__line-horizontal"></div>
    <div class="card__line-vertical"></div>
</div>